export default "__VITE_ASSET__DO12wDYI__"